/*
 * @Description: 
 * @Autor: wk
 * @Date: 2019-05-18 10:42:34
 * @LastEditors: 一诺(丘汉文)
 * @LastEditTime: 2020-03-20 14:52:39
 */
class Util {
  /**
   * 检测某值在数组中是否存在 并返回存在的索引值
   * arr         数组集合（一维json数组）
   * value       json的key值
   * checkKey    检测的key值
   * 用法：let arrlist = [{name:'张三',sex:'男'},{name:'李四',sex:'女'}]
   * isInArrayAndIndex(arrlist,'张三','name')
   * */
  isInArrayAndIndex = (arr, value, checkKey) => {
    const result = {
      isin: false,
      index: 0
    }
    for (let i = 0, len = arr.length; i < len; i += 1) {
      if (value == arr[i][checkKey]) {
        result.isin = true
        result.index = i
      }
    }
    return result
  }

  /** *
   * 检查是否对应用户
   * arr         数组集合
   * value       json的key值 
   * * */
  checkarrflg = (arr, value) => {
    const result = {
      index: 0,
      flg: false
    }
    arr.forEach((i, v) => {
      if (value === i.content.consumerId) {
        result.index = v
        result.flg = true
      }
    })
    return result
  }

  /** *时间* */
  FormatDate = (date, type) => {
    if (!date) return ''
    date = typeof date === 'number' ? new Date(date) : date
    type = type || 'yyyy-MM-dd HH:mm:ss'
    const obj = {
      y: date.getFullYear(), // 年份，注意必须用getFullYear
      M: date.getMonth() + 1, // 月份，注意是从0-11
      d: date.getDate(), // 日期
      q: Math.floor((date.getMonth() + 3) / 3), // 季度
      w: date.getDay(), // 星期，注意是0-6
      H: date.getHours(), // 24小时制
      h: date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 12小时制
      m: date.getMinutes(), // 分钟
      s: date.getSeconds(), // 秒
      S: date.getMilliseconds() // 毫秒
    }
    const week = ['天', '一', '二', '三', '四', '五', '六']
    for (const i in obj) {
      type = type.replace(new RegExp(`${i}+`, 'g'), (m) => {
        let val = `${obj[i]}`
        if (i === 'w') return (m.length > 2 ? '星期' : '周') + week[val]
        for (let j = 0, len = val.length; j < m.length - len; j += 1) val = `0${val}`
        return m.length === 1 ? val : val.substring(val.length - m.length)
      })
    }
    return type
  }

  // 处理消息中需要将content转换json情况
  parseContent = (data) => {
    if (data.type === 1 || data.type === 2 || data.type === 10 || data.type === 14 || data.cmd === 1 || data.type === 16 || data.cmd == 23 || data.cmd == 22 || data.cmd == 0 && data.type === 21 || data.cmd == 0 && data.type === 12) {
      try {
        data.content = JSON.parse(data.content)
      } catch (error) {
        data.content = data.content
      }
    }
    return data
  }
}
export default new Util()
